module.exports = __webpack_public_path__ + "static/media/revicons.2feb69cc.eot";